var exports = {
  "A": "xae11d333--2c2dd4--item",
};

module.exports = exports;
